import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { currentMonth, shiftMonth } from './shared';
import { frenchDay } from './calendar';

export const MonthPicker = ({ month, onChange, prefix = 'internal-month' }) => {
  const label = frenchDay(`${month}-01`, 'MMMM yyyy');
  const isCurrent = month === currentMonth();
  return <div className="flex items-center gap-2 flex-wrap" data-testid={`${prefix}-picker`}>
    <Button variant="outline" size="icon" aria-label="Mois précédent" onClick={() => onChange(shiftMonth(month, -1))} data-testid={`${prefix}-prev`}><ChevronLeft className="w-4 h-4" /></Button>
    <p className="font-semibold capitalize tabular-nums min-w-[9rem] text-center" data-testid={`${prefix}-label`}>{label}</p>
    <Button variant="outline" size="icon" aria-label="Mois suivant" onClick={() => onChange(shiftMonth(month, 1))} data-testid={`${prefix}-next`}><ChevronRight className="w-4 h-4" /></Button>
    {!isCurrent && <Button variant="ghost" size="sm" onClick={() => onChange(currentMonth())} data-testid={`${prefix}-current`}>Ce mois-ci</Button>}
  </div>;
};
